import { Chip, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { ManagementWidgetShell, severityChipColor, severityLabel } from "./managementDashboardWidgets";
import { buildDrillDownHref } from "./managementDashboardUtils";

const ManagementAlertsSection = ({ loading, error, data, onRetry }) => {
  const summary = data?.summary || data?.Summary || {};
  const alerts = data?.alerts || data?.Alerts || [];

  return (
    <ManagementWidgetShell
      title="هشدارهای مدیریتی"
      subheader="اولویت: بحرانی → هشدار → اطلاع"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
        <Chip color="error" label={`بحرانی: ${summary.criticalAlertCount ?? summary.CriticalAlertCount ?? 0}`} />
        <Chip color="warning" label={`هشدار: ${summary.warningAlertCount ?? summary.WarningAlertCount ?? 0}`} />
        <Chip label={`درخواست‌های متاثر (تقریبی): ${summary.affectedRequestCount ?? summary.AffectedRequestCount ?? 0}`} />
      </Stack>
      <Stack spacing={1}>
        {alerts.filter((a) => (a.count ?? a.Count) > 0).map((alert) => {
          const code = alert.code || alert.Code;
          const href = buildDrillDownHref(alert.drillDown || alert.DrillDown);
          const severity = alert.severity || alert.Severity;
          return (
            <Stack
              key={code}
              direction={{ xs: "column", md: "row" }}
              spacing={1}
              alignItems={{ md: "center" }}
              justifyContent="space-between"
              sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1 }}
            >
              <Stack spacing={0.5}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Chip size="small" color={severityChipColor(severity)} label={severityLabel(severity)} />
                  <Typography fontWeight={600}>{alert.title || alert.Title}</Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  {alert.description || alert.Description}
                </Typography>
              </Stack>
              {href ? (
                <Chip
                  component={RouterLink}
                  to={href}
                  clickable
                  color="primary"
                  label={`${alert.count ?? alert.Count} مورد`}
                />
              ) : (
                <Chip label={`${alert.count ?? alert.Count} مورد`} />
              )}
            </Stack>
          );
        })}
        {!alerts.length ? <Typography color="text.secondary">هشدار فعالی یافت نشد.</Typography> : null}
      </Stack>
    </ManagementWidgetShell>
  );
};

export default ManagementAlertsSection;
